module.exports = __webpack_public_path__ + "static/nas-208bef105b0b73aa57a6cca48f0f42a9.jpg";